import { PackageCheck, Handshake, Search, Globe2, ShieldCheck } from "lucide-react";

export const services = [
  {
    slug: "commerce-de-gros",
    num: "01",
    title: "Commerce de gros de produits non alimentaires",
    short: "Achat, revente et distribution en gros à destination des professionnels.",
    description:
      "Achat, revente et distribution de produits non alimentaires en gros, à destination de professionnels : revendeurs, distributeurs, industriels, collectivités, artisans et entreprises.",
    prestations: [
      "Achat-revente de lots et de volumes professionnels",
      "Distribution auprès de revendeurs et distributeurs",
      "Approvisionnement récurrent ou ponctuel",
      "Conditionnement et préparation selon vos spécifications",
      "Facturation professionnelle en euros",
    ],
    icon: PackageCheck,
  },
  {
    slug: "negoce-interentreprises",
    num: "02",
    title: "Services interentreprises de négoce",
    short: "Mise en relation, négociation et intermédiation commerciale entre professionnels.",
    description:
      "Mise en relation, sourcing, négociation, achat-revente et intermédiation commerciale entre professionnels, en France et à l'étranger.",
    prestations: [
      "Mise en relation qualifiée entre acheteurs et fournisseurs",
      "Négociation des conditions commerciales",
      "Intermédiation et suivi de la transaction",
      "Achat-revente pour compte propre",
    ],
    icon: Handshake,
  },
  {
    slug: "sourcing-approvisionnement",
    num: "03",
    title: "Sourcing et approvisionnement",
    short: "Identification de fournisseurs, comparaison d'offres et suivi des commandes.",
    description:
      "Identification de fournisseurs, comparaison d'offres, contrôle des spécifications, organisation du transport et de la logistique, suivi des commandes.",
    prestations: [
      "Recherche et qualification de fournisseurs",
      "Comparaison d'offres et analyse des spécifications",
      "Organisation du transport et de la logistique",
      "Suivi des commandes jusqu'à la livraison",
      "Reporting régulier à l'acheteur",
    ],
    icon: Search,
  },
  {
    slug: "negoce-international",
    num: "04",
    title: "Négoce international",
    short: "Opérations d'import/export et coordination documentaire.",
    description:
      "Opérations d'achat-revente à l'import/export, gestion documentaire commerciale, coordination avec les partenaires et prestataires.",
    prestations: [
      "Achat-revente à l'import et à l'export",
      "Gestion documentaire commerciale (factures, listes de colisage, incoterms)",
      "Coordination transitaires, transporteurs et partenaires",
      "Suivi des opérations douanières avec les prestataires habilités",
    ],
    icon: Globe2,
  },
  {
    slug: "accompagnement-sur-mesure",
    num: "05",
    title: "Accompagnement sur mesure",
    short: "Chaque demande fait l'objet d'une étude spécifique et d'une proposition personnalisée.",
    description:
      "Chaque demande fait l'objet d'une étude spécifique et d'une proposition personnalisée, adaptée à votre activité, vos volumes et vos contraintes.",
    prestations: [
      "Étude de votre besoin et de vos contraintes",
      "Proposition chiffrée personnalisée",
      "Interlocuteur unique pendant toute la mission",
      "Adaptation des modalités au cas par cas",
    ],
    icon: ShieldCheck,
  },
];

export const serviceOptions = [...services.map((s) => s.title), "Autre"];

export const faq = [
  {
    q: "Travaillez-vous uniquement avec des professionnels ?",
    a: "Oui. MINES DE PARIS exerce une activité exclusivement B2B (interentreprises). Nos services s'adressent aux sociétés, artisans, collectivités et autres professionnels.",
  },
  {
    q: "Sous quel délai recevrai-je mon devis ?",
    a: "Nous nous efforçons de répondre à toute demande sous 1 jour ouvré et de transmettre une proposition chiffrée sous 48 heures ouvrées lorsque les informations fournies sont complètes. Pour les demandes complexes, un délai ajusté vous est communiqué.",
  },
  {
    q: "Quels sont les volumes minimums ?",
    a: "Il n'existe pas de minimum fixe : les volumes dépendent des produits, des fournisseurs et des conditions logistiques. Les quantités minimales éventuelles sont précisées dans le devis.",
  },
  {
    q: "Intervenez-vous à l'international ?",
    a: "Oui, en France métropolitaine et à l'international. Les modalités (incoterms, transport, formalités) sont définies au cas par cas et précisées dans le devis.",
  },
  {
    q: "Comment se déroule la facturation ?",
    a: "La facturation est établie en euros, hors taxes, TVA en sus au taux en vigueur. Les modalités de paiement sont indiquées dans le devis et encadrées par nos Conditions Générales de Vente.",
  },
  {
    q: "Puis-je vous confier une recherche de fournisseur ponctuelle ?",
    a: "Oui. Une recherche ponctuelle fait l'objet d'une étude spécifique et d'une proposition dédiée. Indiquez « Recherche de fournisseur » dans le formulaire de devis.",
  },
  {
    q: "Mes informations restent-elles confidentielles ?",
    a: "Oui. Les informations transmises sont confidentielles et ne sont en aucun cas cédées à des tiers. Elles sont traitées conformément à notre politique de confidentialité.",
  },
  {
    q: "Quels types de produits non alimentaires traitez-vous ?",
    a: "Notre objet social couvre l'ensemble des produits non alimentaires. Chaque catégorie est étudiée au cas par cas en fonction de la réglementation applicable et de la faisabilité ; nous vous confirmons rapidement si nous pouvons traiter votre demande.",
  },
];
